import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/images-separator.module.css";
import {
  ColorScheme,
  ImageModuleSettings,
  ImagesModuleSettings,
  TranslatedModule,
} from "../types/index.js";
import ImageModule from "./Modules/ImageModule.js";

interface Props {
  pageId: string;
  images: TranslatedModule<ImageModuleSettings>[];
  isInsideHeader: boolean;
  scheme: ColorScheme;
  isPreview: boolean;
  settings: ImagesModuleSettings["global"];
}

const ImagesSeparator: FunctionComponent<Props> = ({
  images,
  isInsideHeader,
  isPreview,
  scheme,
  settings: { columnsCount, mediaAspectRatio, gap },
  pageId,
}) => (
  <div className={styles.ImagesSeparator}>
    <div
      className={ClassNames(styles.ImagesSeparator__Inner, {
        [styles["ImagesSeparator__Inner--gap-small"]]: gap === "small",
        [styles["ImagesSeparator__Inner--gap-medium"]]: gap === "medium",
        [styles["ImagesSeparator__Inner--gap-big"]]: gap === "big",
        [styles["ImagesSeparator__Inner--columns-2"]]: columnsCount === 2,
        [styles["ImagesSeparator__Inner--columns-3"]]: columnsCount === 3,
        [styles["ImagesSeparator__Inner--columns-4"]]: columnsCount === 4,
        [styles["ImagesSeparator__Inner--columns-5"]]: columnsCount === 5,
        [styles["ImagesSeparator__Inner--columns-6"]]: columnsCount === 6,
      })}
    >
      {images.map((image) => (
        <div className={styles.ImagesSeparator__Item} key={image.id}>
          <ImageModule
            aspectRatio={mediaAspectRatio}
            translatedModule={image}
            width={1920}
            sizes={Math.round((1 / columnsCount) * 100) + "vw"}
            lazyLoad={!isInsideHeader}
            scheme={scheme}
            isPreview={isPreview}
            isSlider={false}
            pageId={pageId}
            showOverlay={true}
          />
        </div>
      ))}
    </div>
  </div>
);

export default ImagesSeparator;
